$(document).ready(function() {
  const client = algoliasearch('WI85SCF99Q',
  'f8f6e4bdadc661b17a2653422e249926');
  const index = client.initIndex('shopify_products');

  const typeDD = document.getElementById('pfType')
  const manufacturerDD = document.getElementById('pfManufacturer')
  const seriesDD = document.getElementById('pfSeries')
  const modelDD = document.getElementById('pfModel')
  const SearchBtn = document.getElementById('pfSearch')

    let productUrl = ''

  const searchForType = () => {
    index.searchForFacetValues('named_tags.Type', '').then((res) => {
      const {facetHits} = res
      var defaultOpt = document.createElement('option');
      defaultOpt.value = ''
      defaultOpt.innerHTML = 'Select Type'
//         typeDD.appendChild(defaultOpt)
      facetHits.map((cat) => {
        var opt = document.createElement('option');
        opt.value = cat.value;
        opt.innerHTML = cat.value;
        typeDD.appendChild(opt)
      })
    })
  }

  const searchForManufacturer = () => {
    index.searchForFacetValues('named_tags.Manufacturer', '', {
        filters: `named_tags.Type:"${typeDD.value}"`
      }).then((res) => {
        $(manufacturerDD).empty();
      const {facetHits} = res
      var defaultOpt = document.createElement('option');
        defaultOpt.value = ''
        defaultOpt.innerHTML = 'Select Manufacturer'
        manufacturerDD.appendChild(defaultOpt)
      facetHits.map((cat) => {
        var opt = document.createElement('option');
        opt.value = cat.value;
        opt.innerHTML = cat.value;
        manufacturerDD.appendChild(opt)
      })
    })
  }

  const searchForSeries = async () => {
    index.searchForFacetValues('named_tags.Series', '', {
        filters: `named_tags.Type:"${typeDD.value}" AND named_tags.Manufacturer:"${manufacturerDD.value}"`
      }).then((res) => {
        $(seriesDD).empty();
        const {facetHits} = res
        var defaultOpt = document.createElement('option');
        defaultOpt.value = ''
        defaultOpt.innerHTML = 'Select Series'
        seriesDD.appendChild(defaultOpt)
        facetHits.forEach((cat) => {
          var opt = document.createElement('option');
          opt.value = cat.value;
          opt.innerHTML = cat.value;
          seriesDD.appendChild(opt)
        })

        if (facetHits.length === 0 || (facetHits.length === 1 && facetHits[0].value === "All")) {
          var allOpt = document.createElement("option");
          allOpt.value = "All";
          allOpt.innerHTML = "All";
          seriesDD.appendChild(allOpt);
          seriesDD.value = "All";
          seriesDD.style.display = "none";
          
          const event = new Event("change", { bubbles: true });
          seriesDD.dispatchEvent(event);
        } else {
          seriesDD.style.display = "block";
        }
      })
  }

  const searchForModels = async () => {
    index.searchForFacetValues('named_tags.Model', '', {
        filters: `named_tags.Type:"${typeDD.value}" AND named_tags.Manufacturer:"${manufacturerDD.value}" AND named_tags.Series:"${seriesDD.value}"`
      }).then((res) => {
        $(modelDD).empty();
        var defaultOpt = document.createElement('option');
        defaultOpt.value = ''
        defaultOpt.innerHTML = 'Select Model'
        modelDD.appendChild(defaultOpt)
        const {facetHits} = res
        facetHits.map((cat) => {
          var opt = document.createElement('option');
          opt.value = cat.value;
          opt.innerHTML = cat.value;
          modelDD.appendChild(opt)
        })
      })
  }



  const searchForProduct = () => {
    productUrl = `/collections/${manufacturerDD.value
      .toLowerCase()
      .replace(' ', '-')}-${modelDD.value
      .toLowerCase()
      .replace(' ', '-')
      .replace('.', '-')}`
  }

  const resetManufacturer = () => {
    manufacturerDD.disabled = true
    $(manufacturerDD).empty()
    var defaultOpt = document.createElement('option');
    defaultOpt.value = ''
    defaultOpt.innerHTML = 'Select Model'
    manufacturerDD.appendChild(defaultOpt)
  }

  const resetModel = () => {
    modelDD.disabled = true
    $(modelDD).empty()
    var defaultOpt = document.createElement('option');
    defaultOpt.value = ''
    defaultOpt.innerHTML = 'Select Model'
    modelDD.appendChild(defaultOpt)
  }

  const resetSeries = () => {
    seriesDD.disabled = true
    $(seriesDD).empty()
    var defaultOpt = document.createElement('option');
    defaultOpt.value = ''
    defaultOpt.innerHTML = 'Select Series'
    seriesDD.appendChild(defaultOpt)
  }


  if(typeDD) {
    searchForType()
  }

  typeDD.addEventListener('change', function(e) {
    if(e.target.value == '') {
      resetManufacturer()
      resetSeries()
      resetModel()
      SearchBtn.setAttribute('disabled', true)
    } else {
      searchForManufacturer()
      manufacturerDD.disabled = false
    }
  })

  manufacturerDD.addEventListener('change', function(e) {
    if(e.target.value == '') {
      resetSeries()
      resetModel()
      SearchBtn.setAttribute('disabled', true)
    } else {
      searchForSeries()
      seriesDD.disabled = false
    }
  })


  seriesDD.addEventListener('change', function(e) {
    if(e.target.value == '') {
      resetModel()
      SearchBtn.disabled = true
    } else {
      searchForModels()
      modelDD.disabled = false
    }
  })
    
    modelDD.addEventListener('change', function(e) {
      if(e.target.value == '') {
        SearchBtn.disabled = true
      } else {
        SearchBtn.disabled = false 
      }
      searchForProduct()
    })

    



    SearchBtn.addEventListener('click', function() {
      if(productUrl !== '') window.location.href = productUrl
    })
})

